export default function HeaderUs() {
  return (
    <div className="containerHeaderUs">
      <div className="bg-landingUs bg-no-repeat bg-center bg-cover"></div>
    </div>
  );
}
